import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChatActionsComponent } from './chat-actions.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  declarations: [
    ChatActionsComponent
  ],
  exports: [
    ChatActionsComponent
  ]
})
export class ChatActionsModule {}
